import { fg } from '@atlassian/jira-feature-gating';

const issuewatchersRelayProvider = {
	get(): boolean {
		return fg('relay_migration_issue_watchers');
	},
};

export default issuewatchersRelayProvider;
